import React, {Component, Ref} from "react"
import SlickSlider from "react-slick"
import {get} from "lodash"

import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import authentication from "@irati/auth"
import OnboardingService from "@irati/onboarding/services/onboarding"
import OnboardingStep from "@irati/onboarding/enums/Step"
import tracking from "@irati-tracking/recognition/shared"

import {Slide} from "./styled/Slider"
import {Step1, Step2, Step3} from "./Steps"
import modalImage from "../../images/onboarding/modalHeader.png"
import {StyledModal} from "./styled/Modal"

type HideOptions = {
  finished?: boolean
}

const LEGACY_ONBOARDING_STORAGE_KEY = "hideOnboarding"

interface Props extends WithAuth {}

interface State {
  showModal: boolean
}

class Onboarding extends Component<Props, State> {
  slider: Ref<SlickSlider> = null

  sliderSettings = {
    dots: false,
    infinite: false,
    accessibility: false,
    draggable: false,
    cssEase: "ease-in-out",
    speed: 400,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    swipe: false,
    adaptiveHeight: true,
    className: "onboarding-slider-list"
  }

  state = {
    showModal: false
  }

  componentDidMount() {
    // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
    const showModalLegacyCheck = localStorage.getItem(LEGACY_ONBOARDING_STORAGE_KEY)
    if (!authentication.isUserGhost()) {
      OnboardingService.get(authentication.user().uuid).then((res) => {
        const showModal = !res.completedSteps.includes(OnboardingStep.HAS_COMPLETED_RECOGNITION_WELCOME_TOUR)
        // If the service thinks the user should see the tour but they have the LocalStorage, fire an update
        if (showModal && showModalLegacyCheck) {
          this.neverShowTourAgain()
          this.setState({showModal: false})
        } else {
          this.setState({showModal})
        }
      })
    }
  }

  neverShowTourAgain = () => OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_COMPLETED_RECOGNITION_WELCOME_TOUR)

  hide = (options?: HideOptions) => {
    this.neverShowTourAgain()
    const isFinished = get(options, "finished", false)
    tracking.welcomeTutorial(isFinished)
    this.setState({showModal: false})
  }

  next = () => {
    if (this.slider) {
      this.slider.slickNext()
    }
  }

  render() {
    const {showModal} = this.state
    return (
      <StyledModal show={showModal} image={modalImage}>
        <SlickSlider
          {...this.sliderSettings}
          ref={(slider: Ref<SlickSlider>) => {
            this.slider = slider
          }}>
          <Slide>
            <Step1 onNext={this.next} onSkip={this.hide} />
          </Slide>
          <Slide>
            <Step2 onNext={this.next} onSkip={this.hide} />
          </Slide>
          <Slide>
            <Step3 onNext={() => this.hide({finished: true})} />
          </Slide>
        </SlickSlider>
      </StyledModal>
    )
  }
}

export default withAuth(Onboarding)
